import { useState } from "react";
import SectionTitle from "./SectionTitle";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="常见问题"
          title="关于在线观看、下载与播放的高频疑问"
          align="center"
          desc="这里汇总了使用过程中最常被提到的疑问，点击问题即可展开答案。"
        />

        <div className="space-y-3">
          {faqs.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={item.q}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center gap-3 text-left px-5 py-4 hover:bg-background-100 transition-colors"
                >
                  <span className="text-sm font-semibold text-primary-700 shrink-0">
                    Q{String(idx + 1).padStart(2, "0")}
                  </span>
                  <h3 className="flex-1 text-sm md:text-base font-medium text-foreground-950">
                    {item.q}
                  </h3>
                  <i
                    className={`ri-add-line text-xl text-foreground-500 transition-transform ${
                      isOpen ? "rotate-45" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-[62px]">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}